var render = function render(_c, _vm) {
  return _c(
    "search-live",
    _vm._b({ attrs: { isTrack: true } }, "search-live", _vm.props, false)
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }